import { render, staticRenderFns } from "./LocalDataSaveToggle.vue?vue&type=template&id=68564d62&scoped=true"
import script from "./LocalDataSaveToggle.vue?vue&type=script&lang=js"
export * from "./LocalDataSaveToggle.vue?vue&type=script&lang=js"
import style0 from "./LocalDataSaveToggle.vue?vue&type=style&index=0&id=68564d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68564d62",
  null
  
)

export default component.exports